/// <reference path="../../../Scripts/typings/knockout/knockout.d.ts" />
/// <reference path="../../../Scripts/typings/linq/linq.d.ts" />
define('widgets/dataList/model',["require", "exports"], function (require, exports) {
    "use strict";
    var GridColumn = (function () {
        function GridColumn() {
            this.headerText = "column";
            this.sortable = false;
            this.width = "auto";
            this.template = "";
            this.canSelectAll = false;
            this.i18n = null;
            this.sortDirection = ko.observable("");
        }
        Object.defineProperty(GridColumn.prototype, "header", {
            get: function () {
                var caption = $.t(this.i18n, { ifMissing: this.headerText });
                if (caption == null || caption === "")
                    caption = this.headerText;
                return caption;
            },
            enumerable: true,
            configurable: true
        });
        return GridColumn;
    }());
    exports.GridColumn = GridColumn;
});

